const value = {
    'global-allow-any': 'Доступ ко всему',
    'is-have-access-to-projects': 'Доступ к проектам',
    'project-in-team-read': 'Чтение проектов в команде',
    'project-not-in-team-access': 'Доступ к проектам без проектных прав',
    'project-not-in-team-permission-update-team-project': 'Доступ к редактированию команды проектов без проектных прав',
    'project-not-in-team-permission-update-fields-project': 'Доступ к редактированию полей проектов без проектных прав',
    'project-not-in-team-permission-update-project': 'Доступ к обновлению проектов без проектных прав',
    'project-not-in-team-permission-jira-intergration': 'Доступ к интеграции АС с Jira',
    'project-not-in-team-permission-create-project': 'Доступ к созданию проектов без проектных прав',
    'project-not-in-team-permission-delete-project': 'Доступ к удалению проектов без проектных прав',
    'project-not-in-team-permission-create-application': 'Доступ к созданию систем без проектных прав',
    'project-not-in-team-permission-update-application': 'Доступ к обновлению систем без проектных прав',
    'project-not-in-team-permission-delete-application': 'Доступ к удалению систем без проектных прав',
    'project-not-in-team-permission-report-access': 'Доступ к отчётам систем без проектных прав',
    'project-not-in-team-permission-custom-requirement-access':
      'Доступ к локальным требованиям систем без проектных прав',
    'project-not-in-team-permission-accept-cancel-access':
      'Доступ к принятию/исключению требований систем без проектных прав',
    'project-not-in-team-permission-show-regulators': 'Доступ к просмотру требований внешних регуляторов\n',
    'project-not-in-team-permission-new-comments-access': 'Доступ к получению новых комментарий без проектных прав',
    'project-not-in-team-permission-show-unverified-requirements-access': 'Просмотр неверифицированных требований',
    'settings-is-allow': 'Доступ к настройкам',
    'settings-specifications-delete': 'Доступ к удалению характеристик',
    'settings-specifications-create': 'Доступ к созданию характеристик',
    'settings-specifications-update': 'Доступ к обновлению характеристик',
    'settings-specifications-read': 'Доступ к чтению характеристик',
    'settings-requirements-delete': 'Доступ к удалению требований',
    'settings-requirements-create': 'Доступ к созданию требований',
    'settings-requirements-update': 'Доступ к обновлению требований',
    'settings-requirements-read': 'Доступ к чтению требований',
    'settings-requirement-vendors-delete': 'Доступ к удалению регуляторов',
    'settings-requirement-vendors-create': 'Доступ к созданию регуляторов',
    'settings-requirement-vendors-update': 'Доступ к обновлению регуляторов',
    'settings-requirement-vendors-read': 'Доступ к чтению регуляторов',
    'settings-tags-delete': 'Доступ к удалению тегов',
    'settings-tags-create': 'Доступ к созданию тегов',
    'settings-tags-update': 'Доступ к обновлению тегов',
    'settings-tags-read': 'Доступ к чтению тегов',
    'settings-statuses-delete': 'Доступ к удалению статусов',
    'settings-statuses-create': 'Доступ к созданию статусов',
    'settings-statuses-update': 'Доступ к обновлению статусов',
    'settings-statuses-read': 'Доступ к чтению статусов',
    'settings-requirements-accept': 'Доступ к верефикации требований',
    'settings-performers-delete': 'Доступ к удалению исполнителей требований',
    'settings-performers-create': 'Доступ к созданию исполнителей требований',
    'settings-performers-update': 'Доступ к обновлению исполнителей требований',
    'settings-performers-read': 'Доступ к чтению исполнителей требований',
    'settings-additional-columns-delete': 'Доступ к удалению дополнительных колонок',
    'settings-additional-columns-create': 'Доступ к созданию дополнительных колонок',
    'settings-additional-columns-update': 'Доступ к обновлению дополнительных колонок',
    'settings-additional-columns-read': 'Доступ к чтению дополнительных колонок',
    'settings-integrations-delete': 'Доступ к удалению интеграциям',
    'settings-integrations-create': 'Доступ к созданию интеграциям',
    'settings-integrations-update': 'Доступ к обновлению интеграциям',
    'settings-integrations-read': 'Доступ к чтению интеграциям',
    'settings-application-template-delete': 'Доступ к удалению шаблонов систем',
    'settings-application-template-create': 'Доступ к созданию шаблонов систем',
    'settings-application-template-update': 'Доступ к обновлению шаблонов систем',
    'settings-application-template-read': 'Доступ к чтению шаблонов систем',
    'settings-user-entity-delete': 'Доступ к удалению пользователей',
    'settings-user-entity-create': 'Доступ к созданию пользователей',
    'settings-user-entity-update': 'Доступ к обновлению пользователей',
    'settings-user-entity-read': 'Доступ к чтению пользователей',
    'settings-user-project-role-delete': 'Доступ к удалению проектных ролей',
    'settings-user-project-role-create': 'Доступ к созданию проектных ролей',
    'settings-user-project-role-update': 'Доступ к обновлению проектных ролей',
    'settings-user-project-role-read': 'Доступ к чтению проектных ролей',
    'settings-user-system-role-delete': 'Доступ к удалению системных ролей',
    'settings-user-system-role-create': 'Доступ к созданию системных ролей',
    'settings-user-system-role-update': 'Доступ к обновлению системных ролей',
    'settings-user-system-role-read': 'Доступ к чтению системных ролей',
    'settings-user-system-role-application-transfer': 'Есть возможность переносить/копировать системы',
    addRoleModal: {
      noRestrictions: 'Нет ограничений',
      accessToTheProjectsSection: 'Доступ к разделу "Проекты"',
      accessInProjectsWithoutAnyProjectRole: 'Доступ в проектах без проектной роли',
      rightsInProjectsWithoutAnyProjectRole: 'Права в проектах без проектной Роли',
      itIsPossibleToTransferOrCopySystems: 'Есть возможность переносить/копировать системы',
      notificationSettings: 'Настройка уведомлений',
      accessToSettingsIsAvailable: 'Есть доступ к настройкам',
      settingsFeaturesOfAS: 'Настройки - Характеристики АС',
      settingsTemplatesOfRequirements: 'Настройки - Шаблоны требований',
      settingsRequirementsOfExternalRegulatoryAuthorities: 'Настройки - Требования внешних регуляторов',
      settingsTagsForRequirements: 'Настройки - Тэги для требований',
      settingsStatuses: 'Настройки - Статусы',
      settingsExecutorsOfRequirements: 'Настройки - Исполнители требований',
      settingsAdditionalColumns: 'Настройки - Дополнительные колонки',
      settingsIntegrations: 'Настройки - Интеграции',
      settingsUsers: 'Настройки - Пользователи',
      settingsSystemRoles: 'Настройки - Системные роли',
      settingsProjectRoles: 'Настройки - Проектные роли',
      settingsTemplatesOfProfiles: 'Настройки - Шаблоны анкет',
      logging: 'Журналирование',
      riskProfile: 'Анкета рисков',
      creatingProjects: 'Создавать проекты',
      editingProjectTeams: 'Редактирование команды проекта',
      editingProjectFields: 'Редактирование полей проекта',
      deletingProjects: 'Удалять проекты',
      creatingSystems: 'Создавать системы',
      updatingSystems: 'Обновлять системы',
      deletingSystems: 'Удалять системы',
      accessToReports: 'Доступ к отчётам',
      viewingUnverifiedRequirements: 'Просмотр неверифицированных требований',
      accessToCreatingOrEditingLocalRequirements: 'Доступ к созданию/редактированию локальных требований',
      acceptingOrCancelingRequirements: 'Возможность принимать/отменять требования',
      viewingRequirementsOfExternalRegulatoryAuthorities: 'Просмотр требовании внешних регуляторов',
      integratingAsWithJira: 'Возможность интегрировать АС с Jira',
      settingTheRequirementsVerificationFlagWhenCreatingASystem:
        'Установка флага верификации требований при создании системы',
      terminatingAcceptanceTests: 'Возможность завершить ПСИ',
      notificationAboutChangingAllStatusesForRequirementsToOneOfTheAvailableValues:
        'Уведомление о переводе всех существующих “Статусов” для требований в одно из существующих значений',
      creatingANewProjectOrChangingTheCurrentProject: 'Создание нового / Изменение текущего проекта',
      creatingANewAsProfileInTheProject: 'Создание новой Анкеты АС в Проекте',
      changingAnExistingAsProfileInTheProject: 'Изменение существующей Анкеты АС в Проекте',
      transferringAnAsProfileToAnotherProject: 'Перенос Анкеты АС в другой Проект',
      copyingAnAsProfileToAnotherProject: 'Копирование Анкеты АС в другой Проект',
      updatingTheAsRequirementsSetAfterChangingTheRequirementsTemplates:
        'Обновление набора требований АС после изменения шаблонов требований',
      creatingANewRequirementsTemplate: 'Создание нового Шаблона требований',
      updatingARequirementsTemplate: 'Обновление Шаблона требования',
      deletingARequirementsTemplate: 'Удаление Шаблона требования',
    },
  };

export default value;
